import { FC, HTMLAttributes } from "react";
import { FullWidthBadges, Trophy } from "../../../store/models/trophy";
import { Badge, BadgeProgress } from "../../elements/Badge/Badge";
import "./TrophyRoomList.css";
import { ToolTipTextArea } from "../ToolTipTextArea/ToolTipTextArea";

export interface TrophyRoomListProps {
  userId?: number;
  studioRoomId?: number;
  studioId?: number;
}

interface TrophyListProps extends HTMLAttributes<HTMLLIElement> {
  trophy: Trophy;
  idx: number;
  hideText?: boolean;
  clipsProjectCompleted?: boolean;
  useProgress?: boolean;
  showOnlyCompleted?: boolean;
  showInfo?: boolean;
  showStatus?: boolean;
  showPublicProfileTitle?: boolean;
}

export const TrophyListItem: FC<TrophyListProps> = ({
  trophy,
  idx,
  hideText = false,
  clipsProjectCompleted = false,
  useProgress = false,
  showOnlyCompleted = true,
  showInfo = true,
  showStatus = true,
  showPublicProfileTitle = false,
  ...props
}) => {
  const BadgeComponent = useProgress ? BadgeProgress : Badge;

  if (showOnlyCompleted && trophy.progress !== 100) {
    return null;
  }

  const textToDisplay = showPublicProfileTitle
    ? trophy.publicProfileTitle
    : trophy.text;

  return (
    <li
      className={"".concat(
        FullWidthBadges.includes(trophy.badgeEnum)
          ? "trophy-list-item"
          : "trophy-list-item",
      )}
      key={idx}
      {...props}
    >
      <BadgeComponent badgeEnum={trophy.badgeEnum} progress={trophy.progress} />
      {!FullWidthBadges.includes(trophy.badgeEnum) && !hideText && (
        <div className="trophy-texts">
          <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
            <p
              className="b3 trophy-list-text"
              style={{
                color: trophy.progress !== 100 ? "gray" : "var(--black)",
              }}
            >
              {clipsProjectCompleted
                ? textToDisplay?.replaceAll(/[^0-9]/g, "")
                : textToDisplay}
            </p>
            {trophy.info && showInfo && <ToolTipTextArea text={trophy.info} />}
          </div>
          {trophy.textStatus && showStatus && (
            <p className="b3 trophy-list-textStatus">{trophy.textStatus}</p>
          )}
        </div>
      )}
    </li>
  );
};
